export default () => {
  function init() {
    const template = document.body.dataset.gtmTemplateName

    if (template === 'index' || template === 'page') {
      trackSectionClick()
    }
  }

  function trackSectionClick() {
    const sections = document.querySelectorAll('#main-content .shopify-section')

    sections.forEach(section => {
      section.addEventListener('click', event => {
        const clickedLinkEl = event.target.closest('a[href]')

        if (!clickedLinkEl) {
          return
        }

        const sectionWrapperEl = event.target.closest('#main-content .shopify-section')
        const sectionOffsets = [...sections].map(el => el.offsetTop)
        const sectionIndex = sectionOffsets.indexOf(sectionWrapperEl.offsetTop)
        const sectionName = sectionWrapperEl.querySelector('[data-component-handle]').dataset.componentHandle

        window.dataLayer.push({
          event: 'page_section_click',
          pageSectionClick: {
            url: document.location.pathname,
            page_section_index: sectionIndex + 1,
            page_section: sectionName.length ? sectionName : 'shopify-section',
            click_url: clickedLinkEl.href,
            click_text: clickedLinkEl.innerText.replaceAll('\n', ''),
          },
        })
      })
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
